import { supabase } from '@/lib/supabase';

export const downloadDocument = async (path: string): Promise<void> => {
  const { data, error } = await supabase.storage
    .from('documents')
    .download(path);

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error('No data received from storage');
  }

  const blobUrl = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = blobUrl;

  const fileName = path.split('/').pop() || 'document';
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(blobUrl);
};
